import {useState} from 'react'

const noop = (() => void 0)

type SetOpen = (open: boolean) => void

export function useSlctMenuOpen(menuOpenExternal: boolean | undefined, setMenuOpenExternal: undefined | SetOpen): { menuOpen: boolean, setMenuOpen: SetOpen, hasMenu: boolean } {
	let hasMenu = true
	let [menuOpen, setMenuOpen] = useState(menuOpenExternal || false)
	if (typeof menuOpenExternal === 'boolean') {
		menuOpen = menuOpenExternal
		hasMenu = Boolean(menuOpenExternal || setMenuOpenExternal)
		setMenuOpen = setMenuOpenExternal || noop
	}
	return {menuOpen, setMenuOpen, hasMenu}
}